import React, {
  FunctionComponent as FC,
  useRef,
  useState,
} from 'react';
import * as d3 from 'd3';
import _ from 'lodash';
import './index.scss';

import PredictionGlyph from '../PredictionGlyph';

interface ImpactCountGlyphProps {
  id: number; 
  grantGroupName: string;
  // grant_field_name: string;
  glyphDataHistorical: any; 
  glyphDataPredicted: any;  
  scaleRDict: any;
  attributeNameDict: any; 
  glyphStyle: any;
  centerGrantNode_MaxMin: number[]; 
}

const ImpactCountGlyph: FC<ImpactCountGlyphProps> = (props) => {
  
  const { id, grantGroupName, glyphDataHistorical, glyphDataPredicted, scaleRDict, attributeNameDict, glyphStyle, centerGrantNode_MaxMin } = props

  // console.log('ImpactCountGlyph: ')
  // console.log('glyphData: ', glyphData)
  // console.log('grantGroupName: ', grantGroupName)
  // console.log('scaleRDict: ', scaleRDict)

  const [textLabelVisibility, setTextLabelVisibility] = useState('hidden')

  // Create a pie generator
  const pie = d3.pie<any>().value(d => d.value).padAngle(0.05); // 0.01 radians = ~0.57 degrees
  const deltaAngle = 0.01
  const rippleWidth = 3
  const cornerRadius = rippleWidth / 2

  // draw glyph
  const drawImpactDonut = (impactData: any, arc_func: any) => {
    const pieData = pie(Object.entries(impactData).map(([key, value]) => ({ key, value })))
    const pieElementList: JSX.Element[] = pieData.map((d: any, i) => {
      return (
        <path
          key={i}
          id='arc-test'
          d={arc_func(d) as any}
          fill={d3.schemeCategory10[i % 10]}
          // stroke={"white"}
          // strokeWidth={0.5}
          strokeLinecap="round"
          // onMouseEnter={() => setTextLabelVisibility('visible')}
          // onMouseLeave={() => setTextLabelVisibility('hidden')}
        >
          <title>{d.data.key}</title>
        </path>
      )
    })
    return pieElementList
  }
  // (1) direct impact
  const directImpactData = _.pick(glyphDataHistorical, attributeNameDict.directImpact)
  const arc_directImpact = d3.arc() // Create an arc generator
    .innerRadius((d: any) => {
      if (d.data.key === 'num_paper') return scaleRDict.directImpact['num_paper'](d.data.value);
      if (d.data.key === 'num_patent') return scaleRDict.directImpact['num_patent'](d.data.value);
      if (d.data.key === 'num_clinical_trial') return scaleRDict.directImpact['num_clinical_trial'](d.data.value);
    })
    .outerRadius((d: any) => {
      if (d.data.key === 'num_paper') return scaleRDict.directImpact['num_paper'](d.data.value) + rippleWidth;
      if (d.data.key === 'num_patent') return scaleRDict.directImpact['num_patent'](d.data.value) + rippleWidth;
      if (d.data.key === 'num_clinical_trial') return scaleRDict.directImpact['num_clinical_trial'](d.data.value) + 2;
    })
    .startAngle(d => d.startAngle - deltaAngle)
    .endAngle(d => d.endAngle + deltaAngle)
    .cornerRadius(cornerRadius)
  const directImpactElementList: JSX.Element[] = drawImpactDonut(directImpactData, arc_directImpact)

  // (2) indirect impact
  // 'num_citing_patent', 'num_citing_clinical_trial', 'num_citing_policy', 'num_citing_newsfeed'
  const indirectImpactData = _.pick(glyphDataHistorical, attributeNameDict.indirectImpact)
  const arc_indirectImpact = d3.arc() // Create an arc generator
    .innerRadius((d: any) => {
      if (d.data.key === 'num_citing_patent') return scaleRDict.indirectImpact['num_citing_patent'](d.data.value);
      if (d.data.key === 'num_citing_clinical_trial') return scaleRDict.indirectImpact['num_citing_clinical_trial'](d.data.value);
      if (d.data.key === 'num_citing_policy') return scaleRDict.indirectImpact['num_citing_policy'](d.data.value);
      if (d.data.key === 'num_citing_newsfeed') return scaleRDict.indirectImpact['num_citing_newsfeed'](d.data.value);
    })
    .outerRadius((d: any) => {
      if (d.data.key === 'num_citing_patent') return scaleRDict.indirectImpact['num_citing_patent'](d.data.value) + rippleWidth;
      if (d.data.key === 'num_citing_clinical_trial') return scaleRDict.indirectImpact['num_citing_clinical_trial'](d.data.value) + rippleWidth;
      if (d.data.key === 'num_citing_policy') return scaleRDict.indirectImpact['num_citing_policy'](d.data.value) + rippleWidth;
      if (d.data.key === 'num_citing_newsfeed') return scaleRDict.indirectImpact['num_citing_newsfeed'](d.data.value) + rippleWidth;
    })
    .startAngle(d => d.startAngle - deltaAngle)
    .endAngle(d => d.endAngle + deltaAngle)
    .cornerRadius(cornerRadius)
  const indirectImpactElementList: JSX.Element[] = drawImpactDonut(indirectImpactData, arc_indirectImpact)

  // (3) inner circle: num_grant: historical + predicted 
  const predictionGlyph: JSX.Element = <PredictionGlyph 
                                    key={id}
                                    id={id} 
                                    grantGroupName={grantGroupName}
                                    glyphDataHistorical={glyphDataHistorical}
                                    glyphDataPredicted={glyphDataPredicted}
                                    glyphStyle = {glyphStyle}
                                    centerGrantNode_MaxMin = {centerGrantNode_MaxMin}
                                  />  

  return (
    <g key={`ImpactCount-g-${id}-${grantGroupName}`}>
      
      {directImpactElementList}
      {indirectImpactElementList}
      <text x={0} y={0} dx={+60} dy={-20} textAnchor="middle" fontSize={8} fill="black" transform='rotate(-30)'>            
        {grantGroupName}
      </text>
      {predictionGlyph}
    </g>
  )
}

export default ImpactCountGlyph;